// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DVgn","placeholdersHeader":"styles_placeholdersHeader__ZLEjn","editorStyle":"styles_editorStyle__2VREc","placeholdersBox":"styles_placeholdersBox__1zDl5"};